import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DefaultButton, PrimaryButton } from '@bingads-webui-react/fabric-with-signal';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react';

export const BasicDialog = (props) => {
  const {
    hidden,
    className,
    title,
    subText,
    content,
    onConfirm,
    onCancel,
    confirmText,
    abortText,
  } = props;
  const i18n = useContext(I18nContext);

  return (
    <Dialog
      hidden={hidden}
      modalProps={{
        className: classNames('form-dialog', className),
      }}
      closeButtonAriaLabel={i18n.getString(_TL_('Close'))}
      onDismiss={onCancel}
      dialogContentProps={{
        showCloseButton: true,
        type: DialogType.normal,
        title,
        subText,
      }}
    >
      {content}
      <DialogFooter>
        <PrimaryButton
          autoFocus
          className="dialog-confirm"
          onClick={onConfirm}
          text={confirmText || i18n.getString(_TL_('Yes'))}
        />
        <DefaultButton
          className="dialog-cancel"
          onClick={onCancel}
          text={abortText || i18n.getString(_TL_('No'))}
        />
      </DialogFooter>
    </Dialog>
  );
};
BasicDialog.propTypes = {
  hidden: PropTypes.bool.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  subText: PropTypes.string,
  content: PropTypes.node,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmText: PropTypes.string,
  abortText: PropTypes.string,
};
BasicDialog.defaultProps = {
  className: undefined,
  title: undefined,
  subText: undefined,
  content: null,
  confirmText: undefined,
  abortText: undefined,
};
